import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth'
import  firebase  from 'firebase/app';
import 'firebase/firestore';
import { from, of, combineLatest, race } from 'rxjs';
import { take, catchError, map, switchMap, tap,mergeMap, first, debounceTime } from 'rxjs/operators';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireFunctions } from '@angular/fire/functions';
import { AngularFireStorage } from '@angular/fire/storage';
import { AngularFireAnalytics } from '@angular/fire/analytics';
import { Router, CanActivate, CanLoad} from '@angular/router'; 
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpClient } from '@angular/common/http';


@Injectable({
    providedIn: 'root'
})


export class AuthService{
    
    pics : Promise<any[]>; 
    user : firebase.User | null;
    localStorage: Storage; 
    sessionStorage: Storage;
    sessionId: string
    constructor(
        private afa: AngularFireAuth, 
        private afs: AngularFirestore, 
        private aff: AngularFireFunctions, 
        private storage: AngularFireStorage, 
        private analytics: AngularFireAnalytics, 
        private router: Router, 
        private snack: MatSnackBar){
        this.localStorage = window.localStorage; 
        this.sessionStorage = window.sessionStorage; 
        if(this.getSessionId() === null){
            const sessionId = this.afs.createId()
            this.sessionStorage.setItem('sessionId', sessionId)
            this.sessionId = sessionId
        }
        else{
            this.sessionId = this.getSessionId()
        }
    }

    getSessionId = () => {
       return this.sessionStorage.getItem('sessionId')
    }

    returnUser = () => {
        // On returning from a signInWithRedirect round-trip, Firebase must finish
        // the token exchange before authState emits the user, so we FIRST await
        // getRedirectResult() (which resolves only once that exchange completes).
        // If it carries a user, use it. Otherwise fall back to the persisted
        // authState: authState emits `null` synchronously before the session is
        // restored, then the real user — so we take the first non-null user, or
        // settle to null for genuinely logged-out visitors (race avoids hanging
        // on the never-completing authState stream).
        return from(this.afa.getRedirectResult()).pipe(
            switchMap(redirect => {
                if (redirect && redirect.user != null) {
                    this.localStorage.setItem('user', JSON.stringify(redirect));
                    return of({ user: redirect.user });
                }
                const firstUser$ = this.afa.authState.pipe(
                    first(user => user != null),
                    map(user => ({ user }))
                );
                const settledNull$ = this.afa.authState.pipe(
                    debounceTime(750),
                    map(user => (user != null ? { user } : null)),
                    take(1)
                );
                return race(firstUser$, settledNull$);
            }),
            catchError(err => {
                if (err.code === 'auth/invalid-credential') {
                    console.error('auth error');
                } else if (err.message !== undefined) {
                    this.snack.open(err.message, 'close');
                }
                return of(null);
            }),
            take(1)
        );
    }
    loginWithEmail = (creds: {email: string, password: string}) => 
     from(this.afa.signInWithEmailAndPassword(creds.email, creds.password))
     .pipe(
        switchMap( (userData) =>{
            return this.afs.collection("Chat-rooms").valueChanges()
            .pipe(
                switchMap(
                    (chatRooms: any[]) => {
                    this.localStorage.setItem('user', JSON.stringify(userData))
                    if(chatRooms){
                            const idx = chatRooms.find( (chatroom) => chatroom?.instructorUid === userData?.user?.uid)
                            if( idx !== undefined){
                                return from(this.afs.collection("Chat-rooms").doc(idx.instructorUid).set({status: 'Online'}  ,{merge: true}))
                                .pipe(
                                    take(1)
                                )
                            }
                            else{
                                if(userData.user != null){
                                    return of(this.router.createUrlTree(["/main"]))
                                }
                                else{
                                    return of(true)
                                }
                            } 
                    }
                    else{
                        return of(true)
                    }
                }),
                catchError((err) => { 
                    this.snack.open(err.message, 'close')
                    return of(true)
                }),
                take(1)
            )
        } ),
        catchError( (err) => {
            this.snack.open(err.message, 'close')
            return of(err)
        }),
        take(1)
     )
     
    loginWithGoogle = (link?) => {
        // Redirect flow (preserved for mobile, where popups are unreliable).
        // This works across modern browsers because the production authDomain is
        // set to the app's custom domain (www.stepup90.com), so the auth iframe
        // and the app share an origin and no third-party storage is needed.
        // See: https://firebase.google.com/docs/auth/web/redirect-best-practices
        return new Promise(
            (res, rej) => {
                const googleAuthProvider = new firebase.auth.GoogleAuthProvider();
                googleAuthProvider.addScope('profile');
                googleAuthProvider.addScope('email');
                googleAuthProvider.setCustomParameters({ prompt: 'select_account' });
                this.afa.signInWithRedirect(googleAuthProvider)
                    .then((user) => { res(user); })
                    .catch(err => rej(err));
            }
        );
    }
    returnUserWithRedirect = () =>  new Promise<any | void>(
        (res, rej) => this.afa.getRedirectResult().then(
            userData => {         
                if(userData?.user !== null ){

                    this.localStorage.setItem('user', JSON.stringify(userData))
                    res(userData)
                }
                else{
                    rej('User not logged in')
                }
                
            }
        ).catch(err => {console.error(err.message); rej(err.message)})
    ) 
    registerUserEmailAndPassword(registerForm){
        return new Promise ( (res, rej) => {
            this.afa.fetchSignInMethodsForEmail(registerForm.email).then(
                (methods) => {
                    if(methods.length === 0){
                        this.afa.createUserWithEmailAndPassword(registerForm.email, registerForm.password)
                        .then(
                            user =>{ 
                                this.afs.collection("Users").doc(user.user.uid).set({dateJoined: firebase.firestore.FieldValue.serverTimestamp(), uid: user.user.uid}, {merge: true})

                                //const actionCode = { url : "https://loveonthefly.com/signup-splash", handleCodeInApp: true}
                                //user.user.sendEmailVerification(actionCode).then(() => {res()}).catch( err => rej(err))
                                user.user.updateProfile({displayName: registerForm.name})
                                .then( 
                                    ( ) => { 
                                        res( 'registered')
                                    }
                                ).catch(
                                    err => {
                                        rej(err)
                                        this.snack.open(err.message, 'close')}
                                )

                                
                            }
                        ).catch( err => {
                            rej(err)
                            this.snack.open(err.message, 'close')})
                    }
                    else{

                        methods.forEach(
                            (method) => {
                                switch(method){
                                    case 'google.com':
                                    this.snack.open("This email is linked with Google, sign in with your Google account.", 'close')                                
                                    break
                                    case 'facebook.com':
                                    this.snack.open("This email is linked with Google, sign in with your Facebook account.", 'close')                                

                                    break
                                }
                            }
                        )
                    }

                }
            ).catch( err => {
                rej(err)
                this.snack.open(err.message, 'close')
            })
            
        } ) 

    }
    addUserPicture = (user: {uid: string, url: string}) =>  { 
        const userPhotoFunc  = this.aff.httpsCallable('saveUserPhoto')
        userPhotoFunc(user)
    }
    getUserPictureLinks = (uid) => this.afs.collection("activeUsers").doc(uid).valueChanges().pipe(catchError( err => of(err)), take(1))
    getUserPicture = (uid) => combineLatest([this.storage.ref(`users/${uid}/picture/users-pic.png`).getDownloadURL(), this.storage.ref(`users/${uid}/picture/users-pic.webp`).getDownloadURL()])
    .pipe(catchError( (err) => { if(err.code === 'storage/object-not-found'){ return of([])}}))
    loginWithFB(){


        return new Promise(
            (res, rej) => {
                const facebookAuth = new firebase.auth.FacebookAuthProvider();
                this.afa.signInWithPopup(facebookAuth)
                .then( (userData) => {
                    this.afa.getRedirectResult()
                    .then(
                        user => {
                            res(user)
                        }
                    )
                    .catch(
                        err => {
                            console.error(err)
                        }
                    )
                })
                .catch(err => {
                    console.error(err.message)
                    rej(err.message)
                })
            }
        )
        
        
    }
    isLocalStorageSupported(): boolean {
        return !!this.localStorage
    }
    logout = () => {
    window.localStorage.removeItem('user')
    return this.returnUser().pipe(
            switchMap( (user) =>{
                return this.afs.collection("Chat-rooms").valueChanges()
                .pipe(
                    map(
                        (chatrooms) => {
                        if(user){
                            const idx = chatrooms.find( (chatroom: any) => chatroom.instructorUid === user.user.uid)
                            if( idx !== undefined){
                                return {
                                    instructorUid: user.user.uid
                                }
                            }
                            else{
                                return user
                            }
                        }
                        else{
                            return true
                        }
                    }),
                    tap(
                        (data) => { 
                            if(data.instructorUid != undefined){
                                this.afs.collection("Chat-rooms").doc(data.instructorUid).set({status: 'Offline'}, {merge:true})
                            }
                         }
                    ),
                    switchMap( () => {
                        return this.afa.signOut().then( () => { 

                            this.router.navigate(['/login'])
                        })
                    }),
                    catchError((err) => { 
                        console.error(err.message)
                        return of(true)
                    }),
                    take(1)
                )
            } )
    ).subscribe()
     
}

    sendPasswordResetLink(email){
        return this.afa.sendPasswordResetEmail(email)
    }
    setGoogleAnalytics(user){
        return this.analytics.setUserProperties(user)
    }

}

@Injectable()
export class UserResolverService{
    constructor(private authSvc: AuthService){}
    resolve(){
        return this.authSvc.returnUser().pipe(
            take(1)
        )
    }
}

@Injectable({providedIn: 'root'})
export class UserActivationService implements CanActivate {
    constructor(private router: Router, private auth: AuthService, private snack: MatSnackBar){}

    canActivate(){
        return this.auth.returnUser().pipe(
            mergeMap( user => { 
                if(user != null){
                    this.router.navigate(['questions', `${this.auth.getSessionId()}`])
                  }
                    else{
                        return of(true)
                    }
                }
            ),
            take(1)
        )
    }
}

@Injectable()


export class AuthLoadService implements CanLoad{
    constructor(private authSvc: AuthService, private router: Router){}
    canLoad(){
        return from(this.authSvc.returnUserWithRedirect())
        .pipe(
            tap( user => { 
                if(user)
                {
                    return true
                }
                else{
                    return false
                }
            })
        )
        
    }
}

@Injectable()

export class AuthServiceActivation implements CanActivate{
    constructor(private router: Router, private afs: AngularFirestore, private authSvc: AuthService){}


    canActivate(){
        return this.authSvc.returnUser().pipe(
            switchMap( (userData) =>{
                // This guard protects the /login route: if the user is already
                // signed in, send them to /main; otherwise let them see the
                // login page. Only authenticated users may read Chat-rooms, so
                // we must NOT query Firestore when there is no user, or the
                // rules reject it with "Missing or insufficient permissions".
                if(userData == null || userData.user == null){
                    return of(true)
                }
                return this.afs.collection("Chat-rooms").valueChanges()
                .pipe(
                    switchMap(
                        (chatRooms: any[]) => {
                        if(chatRooms){
                                const idx = chatRooms.find( (chatroom) => chatroom?.instructorUid === userData?.user?.uid)
                                if( idx !== undefined){
                                    return from(this.afs.collection("Chat-rooms").doc(idx.instructorUid).set({status: 'Online'}  ,{merge: true}))
                                    .pipe(
                                        map(() => this.router.createUrlTree(["/main"]) )
                                    )
                                }
                                else{
                                    return of(this.router.createUrlTree(["/main"]))
                                } 
                        }
                        else{
                            return of(this.router.createUrlTree(["/main"]))
                        }
                    }),
                    catchError((err) => { 
                        console.error(err.message)
                        return of(true)
                    }),
                    take(1)
                )
            } ),
            take(1)
        )
        
        
    }
}